// OCC option symbols end with a 6-digit expiration (YYMMDD), a C/P flag, and an
// 8-digit strike, e.g. QQQ260828P00040000. Plain equity symbols never match this,
// so instances holding both (e.g. GROK after assignment) render correctly per row.
const OCC_OPTION_SUFFIX = /\d{6}([CP])\d{8}$/;

/**
 * Label for a position's side chip: PUT/CALL for option contracts,
 * LONG/SHORT for equity positions.
 */
export function getPositionSideLabel(symbol: string, side: string): string {
  const match = (symbol || '').match(OCC_OPTION_SUFFIX);
  if (match) {
    return match[1] === 'P' ? 'PUT' : 'CALL';
  }
  return (side || '').toUpperCase();
}
